import PrivacyOptIn from './modules/privacy-policy-popup';

PrivacyOptIn();
